export const updatePaymentDescription = paymentItem => {
  if (paymentItem.type === 'credit_card') return `${paymentItem.brand} *${paymentItem.last4}`;
  if (paymentItem.type === 'apple_pay') return 'Apple Pay';
  if (paymentItem.type === 'paypal') return 'PayPal';
  if (paymentItem.type === 'corporate') return paymentItem.label;
  return paymentItem.description;
};
